<template>
  <div class="edit-magazzino" style="padding: 20px">
    <v-overlay :value="showOverlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>Magazzino</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              :disabled="!valid"
              @click="salvaMagazzino"
            >
              <v-icon color="success"> mdi-floppy </v-icon>
            </v-btn>
          </template>
          <span>Salva Magazzino</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="goHome">
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text>
        <v-row dense>
          <!-- Sede -->
          <v-col>
            <v-text-field
              hide-details
              label="Sede"
              dense
              outlined
              v-model="sede_magazzino"
            >
            </v-text-field>
          </v-col>

          <!-- Tipo -->
          <v-col>
            <v-autocomplete
              label="Tipologia"
              dense
              outlined
              hide-details
              v-model="tipologia_magazzino"
              :items="tipologie"
              item-text="des"
              item-value="id_tabella"
              placeholder="Digita per cercare"
            >
              <template #label>
                <span>Tipologia</span>
                <a @click.stop style="pointer-events: all">
                  <Modules
                    v-on:dialogModules="getTipiMagazzino"
                    tipo="TIPO_MAGAZZINO"
                    nome="Tipo"
                    setaction="settabella"
                    getaction="gettabella"
                    controller="Global"
                    filter="validita = 1"
                    :dati="[{ des: '' }]"
                  />
                </a>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- Codice -->
          <v-col>
            <v-text-field
              hide-details
              label="Cod. Magazzino"
              dense
              outlined
              v-model="codice_magazzino"
            >
            </v-text-field>
          </v-col>

          <!-- Descrizione -->
          <v-col>
            <v-text-field
              hide-details
              label="Descrizione Magazzino"
              dense
              outlined
              v-model="descrizione_magazzino"
            >
            </v-text-field>
          </v-col>

          <!-- Utente -->
          <v-col>
            <v-autocomplete
              label="Utente"
              dense
              outlined
              hide-details
              v-model="id_personale_utente"
              :items="lista_personale"
              item-text="nominativo"
              item-value="id_personale"
              placeholder="Digita per cercare"
            >
              <template v-slot:item="{ item }">
                <div>
                  {{ item.nominativo }}
                </div>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row dense>
          <!-- Indirizzo -->
          <v-col>
            <v-text-field
              label="Indirizzo"
              dense
              hide-details
              outlined
              v-model="indirizzo"
            >
            </v-text-field>
          </v-col>

          <!-- CAP -->
          <v-col>
            <v-text-field
              dense
              hide-details
              label="CAP"
              outlined
              type="number"
              v-model="cap"
            >
            </v-text-field>
          </v-col>

          <!-- Località -->
          <v-col>
            <v-autocomplete
              label="Località"
              dense
              outlined
              hide-details
              v-model="comune"
              :items="items_localita"
              item-text="des"
              item-value="val_int"
            >
              <!-- Bottone di cancellazione -->
              <template slot="append">
                <v-icon
                  @click="
                    comune = null;
                    provincia = null;
                    nazione = null;
                  "
                  color="error"
                  v-if="comune != null && comune != ''"
                >
                  mdi-close
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- Provincia -->
          <v-col>
            <v-autocomplete
              label="Provincia"
              dense
              outlined
              hide-details
              v-model="provincia"
              :items="items_province"
              item-text="des"
              item-value="val_int"
              readonly
            >
            </v-autocomplete>
          </v-col>

          <!-- Nazione -->
          <v-col>
            <v-autocomplete
              label="Nazione"
              dense
              outlined
              hide-details
              v-model="nazione"
              :items="items_nazioni"
              item-text="des"
              item-value="val_int"
              readonly
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-autocomplete
              label="Ragione Sociale"
              dense
              outlined
              hide-details
              v-model="id_anagrafica"
              :items="items_anagrafiche"
              item-text="ragione_sociale"
              item-value="id_anagrafica"
            >
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-checkbox
              dense
              :false-value="0"
              :true-value="1"
              hide-details
              label="Magazzino Aggregato"
              @change="chkAggregato"
              v-model="magazzino_aggregato"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-autocomplete
              label="Riferimenti"
              dense
              outlined
              hide-details
              multiple
              v-model="riferimenti"
              v-if="magazzino_aggregato == 1"
              :items="items_magazzini"
              item-text="des_magazzino"
              item-value="id_magazzino"
            >
            </v-autocomplete>
          </v-col>
          <v-col></v-col>
          <v-col></v-col>
        </v-row>

        <v-row v-if="magazzino_aggregato == 0">
          <v-col v-if="struttura_magazzino.length == 0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="mr-2"
                  small
                  elevation="1"
                  @click="creaStruttura()"
                >
                  <v-icon color="primary"> mdi-plus </v-icon>
                </v-btn>
              </template>
              <span>Crea Struttura</span>
            </v-tooltip>
          </v-col>

          <v-treeview
            :items="struttura_magazzino"
            :open.sync="openIds"
            :key="treeKey"
          >
            <template v-slot:prepend="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mr-2"
                    small
                    elevation="1"
                    @click="addChildren(item)"
                  >
                    <v-icon color="primary"> mdi-plus </v-icon>
                  </v-btn>
                </template>
                <span>Aggiungi livello</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mr-2"
                    small
                    elevation="1"
                    @click="showDialogPosizioniMultiple(item)"
                  >
                    <v-icon color="primary">
                      mdi-view-grid-plus-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>Aggiungi livello multiplo</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mx-1"
                    v-on="on"
                    small
                    elevation="1"
                    @click="printItem(item)"
                  >
                    <v-icon color="primary"> mdi-printer </v-icon>
                  </v-btn>
                </template>
                <span>Stampa Etichetta</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mr-2"
                    small
                    elevation="1"
                    @click="editUbicazioneOGruppo(item)"
                  >
                    <v-icon color="primary"> mdi-dolly </v-icon>
                  </v-btn>
                </template>
                <span>Modifica Articoli/Famiglie</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    v-if="item.children == null"
                    class="mr-2"
                    small
                    elevation="1"
                    @click="modifyUbicazione(item)"
                  >
                    <v-icon color="primary"> mdi-pencil </v-icon>
                  </v-btn>
                </template>
                <span>Modifica ubicazione</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    v-if="item.children == null"
                    small
                    elevation="1"
                    class="mr-2"
                    @click="setSingleArticle(item)"
                  >
                    <v-icon color="#1a80b6"> mdi-numeric-1-box </v-icon>
                  </v-btn>
                </template>
                <span>Singolo Articolo</span>
              </v-tooltip>
            </template>

            <template v-slot:append="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" v-if="item.singolo_articolo == 1"
                    >mdi-numeric-1-box</v-icon
                  >
                </template>
                <span>Ubicazione Singolo Articolo</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="item.level > 1"
                    v-on="on"
                    class="ma-5 error--text"
                    small
                    elevation="1"
                    @click="deleteItem(item)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Elimina</span>
              </v-tooltip>

              <v-icon v-if="item.validita == 0" color="error">mdi-close</v-icon>
            </template>
            <template v-slot:label="{ item }">
              <template v-if="item.edit">
                <v-text-field
                  dense
                  autofocus
                  v-model="item.des_dettaglio"
                  @keyup.enter="saveName(item)"
                >
                </v-text-field>
              </template>
              <template v-else>
                <span @click="editItem(item)">
                  {{ item.des_dettaglio }}
                </span>
              </template>
            </template>
          </v-treeview>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="inserimento_posizioni_multiple_visible" width="800">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Inserimento posizioni multiple
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                :disabled="!validAdd"
                @click="addPosizioniMultiple"
              >
                <v-icon color="#1a80b6"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Inserisci</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="chiudiDialogPosizioniMultiple" small>
                <v-icon class="error--text"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pa-0 pt-3">
          <v-container>
            <v-row>
              <v-col cols="4">
                <v-text-field label="Sigla" dense outlined v-model="sigla">
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-combobox
                  label="Cifra iniziale"
                  dense
                  outlined
                  hide-details
                  v-model="cifra_iniziale"
                  :items="lista_cifre"
                >
                </v-combobox>
              </v-col>
              <v-col cols="4">
                <v-combobox
                  label="Cifra finale"
                  dense
                  outlined
                  hide-details
                  v-model="cifra_finale"
                  :items="lista_cifre"
                >
                </v-combobox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUbicazione" width="800">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Modifica Ubicazione
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                elevation="1"
                class="ma-3"
                @click="changeType()"
              >
                <v-icon :color="tempUbicazione.tipo ? 'success' : 'orange'">{{
                  tempUbicazione.tipo ? "mdi-cart" : "mdi-download"
                }}</v-icon>
              </v-btn>
            </template>
            <span>{{
              tempUbicazione.tipo
                ? "Ubicazione Picking"
                : "Ubicazione Refilling"
            }}</span>
          </v-tooltip>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small @click="saveUbicazione">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Ubicazione</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="dialogUbicazione = false" small>
                <v-icon class="error--text"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pa-0 pt-3">
          <v-container>
            <v-row dense>
              <v-col cols="4">
                <v-text-field
                  label="Codice"
                  dense
                  outlined
                  v-model="tempUbicazione.cod_dettaglio"
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Descrizione"
                  dense
                  outlined
                  v-model="tempUbicazione.des_dettaglio"
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Peso Massimo"
                  dense
                  outlined
                  v-model="tempUbicazione.peso_massimo"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="4">
                <v-text-field
                  label="Altezza"
                  dense
                  outlined
                  v-model="tempUbicazione.altezza"
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Larghezza"
                  dense
                  outlined
                  v-model="tempUbicazione.larghezza"
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Profondita"
                  dense
                  outlined
                  v-model="tempUbicazione.profondita"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogStampa" width="800">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Stampa Etichetta</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="confirmPrint()" small>
                <v-icon color="primary"> mdi-printer </v-icon>
              </v-btn>
            </template>
            <span>Stampa</span>
          </v-tooltip>
          <v-spacer></v-spacer>

          <v-tooltip bottom v-if="pdfs.length > 1">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                @click="cPage > 0 ? cPage-- : (cPage = cPage)"
                small
                class="mr-10"
              >
                <v-icon color="primary"> mdi-arrow-left </v-icon>
              </v-btn>
            </template>
            <span>Pagina precedente</span>
          </v-tooltip>

          <v-tooltip bottom v-if="pdfs.length > 1">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                @click="cPage < pdfs.length - 1 ? cPage++ : (cPage = cPage)"
                small
              >
                <v-icon color="primary"> mdi-arrow-right </v-icon>
              </v-btn>
            </template>
            <span>Prossima pagina</span>
          </v-tooltip>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="dialogStampa = false" small>
                <v-icon class="error--text"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>
        <v-col cols="12">
          <iframe
            :src="pdfs[cPage]"
            frameborder="0"
            style="height: 70vh !important; width: 750px !important"
          >
          </iframe>
        </v-col>
      </v-card>
    </v-dialog>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import moment from "moment";
import Modules from "@/components/TOOLS/Modules";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "EditMagazzino",
  props: ["id", "duplicateId"],
  components: {
    Modules,
    SnackbarQV,
  },
  data() {
    return {
      // Variabili di supporto
      aggregabile: 1,
      cap: null,
      cifra_finale: null,
      cifra_iniziale: null,
      codice_magazzino: null,
      comune: null,
      cPage: 0,
      currentEditItem: null,
      currentItem: null,
      des_aggregato: "",
      descrizione_magazzino: null,
      id_anagrafica: null,
      id_personale_utente: null,
      indirizzo: "",
      magazzino_aggregato: 0,
      maxId: 1,
      nazione: null,
      provincia: null,
      request_counter: 0,
      riferimenti: null,
      sede_magazzino: null,
      selectedItem: null,
      sigla: null,
      tempUbicazione: {},
      tipologia_magazzino: null,
      treeKey: 0,

      // Modal
      dialogStampa: false,
      dialogUbicazione: false,
      inserimento_posizioni_multiple_visible: false,
      loading: false,
      showOverlay: false,

      // Array
      items_anagrafiche: new Array(),
      items_localita: new Array(),
      items_magazzini: new Array(),
      items_nazioni: new Array(),
      items_province: new Array(),
      items_regioni: new Array(),
      lista_cifre: [],
      lista_personale: [],
      openIds: [],
      pdfs: [],
      printItems: [],
      struttura_magazzino: [],
      tipologie: [],
    };
  },
  watch: {
    "$route.params.id": function (newT, oldT) {
      if (newT != oldT) {
        this.inizializza();
      }
    },
    comune: {
      immediate: true,
      handler() {
        if (this.comune != null && this.comune != "") {
          this.assegnaProvinciaNazione();
        }
      },
    },
    magazzino_aggregato: {
      immediate: true,
      handler() {
        if (this.magazzino_aggregato == 0) {
          this.riferimenti = null;
        } else {
          this.struttura_magazzino = new Array();
          this.creaStruttura();
        }
      },
    },
    request_counter: {
      immediate: true,
      handler() {
        if (this.request_counter <= 0) {
          this.showOverlay = false;
        }
      },
    },
  },
  computed: {
    valid() {
      if (
        this.sede_magazzino != null &&
        this.tipologia_magazzino != null &&
        this.codice_magazzino != null &&
        this.descrizione_magazzino != null
      ) {
        return true;
      } else {
        return false;
      }
    },
    validAdd() {
      if (
        this.cifra_iniziale &&
        !isNaN(this.cifra_iniziale) &&
        this.cifra_finale &&
        !isNaN(this.cifra_finale) &&
        this.cifra_iniziale >= 1 &&
        this.cifra_iniziale <= 999 &&
        this.cifra_finale >= 1 &&
        this.cifra_finale <= 999 &&
        this.sigla
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getMagazzini();
    this.inizializza();
    this.getPersonaleMagazzinoLibero();
    this.getRagioneSociale();
  },
  methods: {
    assegnaProvinciaNazione() {
      // Recupero il comune.
      const comune_tmp = this.items_localita.filter(
        (l) => l.val_int == this.comune
      )[0];

      // Definisco la provincia in base al comune.
      const provincia_tmp = this.items_province.filter(
        (p) => p.val_int == comune_tmp.val_int1
      )[0];
      this.provincia = provincia_tmp.val_int;

      // Definisco la regione (provvisoriamente) in base alla provincia.
      const regione_tmp = this.items_regioni.filter(
        (r) => r.val_int == provincia_tmp.val_int1
      )[0];

      // Definisco la nazione in base alla regione.
      this.nazione = this.items_nazioni.filter(
        (n) => n.val_int == regione_tmp.val_int1
      )[0].val_int;
    },
    chkAggregato() {
      if (this.magazzino_aggregato == 1 && this.aggregabile == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Questo magazzino non può aggregare perché è già interno a ${this.des_aggregato}.`
        );
        this.$nextTick(() => {
          this.magazzino_aggregato = 0;
        });
      }
    },
    async getPersonaleMagazzinoLibero() {
      try {
        this.loading = true;
        const request = {
          controller: "contabilita",
          method: "POST",
          richiesta: {
            action: "getpersonalemagazzinolibero",
            token: localStorage.user_token,
            id_magazzino: this.id,
          },
        };

        this.showOverlay = true;
        this.request_counter++;
        await this.$store.dispatch("api6", request).then((res) => {
          this.request_counter--;
          this.lista_personale = res.data.result;
          this.lista_personale.forEach(
            (u) => (u.nominativo = u.cognome + " " + u.nome)
          );
          this.lista_personale.sort((a, b) =>
            a.nominativo.localeCompare(b.nominativo)
          );
        });
      } catch (ex) {
        this.request_counter--;
        this.$refs.SnackbarQV.error(ex);
      }
    },
    getRagioneSociale() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getragionesociale",
          token: localStorage.user_token,
          tipo_anagrafica: "R",
        },
      };

      this.showOverlay = true;
      this.request_counter++;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.request_counter--;
          if (res.status === 200) {
            this.items_anagrafiche = res.data;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    async confirmPrint() {
      try {
        this.loading = true;

        const request = {
          controller: "Global",
          method: "POST",
          richiesta: {
            action: "getdispositiviutente",
            token: localStorage.user_token,
          },
        };

        var pName = "";

        await this.$store.dispatch("api", request).then((res) => {
          console.log(res);
          pName = res.data.result.dispositivi[0].nome_dispositivo;
        });

        var request2 = {};

        request2 = {
          controller: "report",
          method: "POST",
          richiesta: {
            action: "getreportpdf",
            token: localStorage.user_token,
            cod_report: "ubicazione",
            printer_name: pName,
            parametri: [
              {
                parametro: "@id_ubicazione",
                valore: this.printItems[this.cPage].id_magazzino_ubicazione,
              },
            ],
          },
        };

        await this.$store.dispatch("api", request2).then((res) => {
          if (
            "tipo_messaggio" in res.data &&
            "query_messaggio" in res.data &&
            res.data.tipo_messaggio == 1
          ) {
            this.$refs.SnackbarQV.print("orange", res.data.query_messaggio);
          } else {
            this.$refs.SnackbarQV.print("success", "Etichetta stampata");
          }
          this.loading = false;
        });
      } catch (err) {
        if (
          "tipo_messaggio" in err.response.data &&
          "query_messaggio" in err.response.data &&
          err.response.data.tipo_messaggio == 2
        ) {
          this.$refs.SnackbarQV.print(
            "error",
            err.response.data.query_messaggio
          );
        } else {
          this.$refs.SnackbarQV.print("error", err.toString());
        }
      }
    },

    changeType() {
      this.tempUbicazione.tipo = !this.tempUbicazione.tipo;
    },
    editUbicazioneOGruppo(item) {
      console.log(item);
      if (item.children == null) {
        this.openUbicazione(item);
      } else {
        this.openUbicazionePadre(item);
      }
    },
    getMagazzini() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmagazzini",
          token: localStorage.user_token,
        },
      };

      this.showOverlay = true;
      this.request_counter++;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.request_counter--;
          if (res.status === 200) {
            this.items_magazzini = res.data;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    goHome() {
      localStorage.setItem("struttura_magazzino_aperto", "null");
      this.$router.push({ name: "home-magazzino" });
    },
    openUbicazione(item) {
      localStorage.setItem(
        "struttura_magazzino_aperto",
        JSON.stringify(this.openIds)
      );
      this.$router.push({
        name: "edit-ubicazione",
        params: {
          id: item.id,
          idMagazzino: item.id_magazzino,
          duplicateId: this.duplicateId,
        },
      });
    },
    openUbicazionePadre(item) {
      localStorage.setItem(
        "struttura_magazzino_aperto",
        JSON.stringify(this.openIds)
      );
      this.$router.push({
        name: "edit-ubicazione-padre",
        params: {
          id: item.id,
          idMagazzino: item.id_magazzino,
          duplicateId: this.duplicateId,
        },
      });
    },
    async inizializza() {
      this.lista_cifre = Array.from({ length: 999 }, (x, i) => i + 1);

      // Prendo comuni, province e regioni
      await this.getTabella();

      if (this.id != -1) {
        var request2 = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getmagazzinoubicazione",
            token: localStorage.user_token,
            id_utente: localStorage.id,
            id_magazzino: this.id,
          },
        };

        this.showOverlay = true;
        this.request_counter++;
        await this.$store
          .dispatch("api", request2)
          .then(async (res) => {
            this.request_counter--;
            if (res.status == 200) {
              if (res.data != undefined) {
                this.sede_magazzino = res.data.magazzino[0].sede_magazzino;
                this.comune = res.data.magazzino[0].localita;
                this.cap = res.data.magazzino[0].cap;
                this.indirizzo = res.data.magazzino[0].indirizzo;
                this.tipologia_magazzino = parseInt(
                  res.data.magazzino[0].id_tipo_magazzino
                );
                this.id_anagrafica = res.data.magazzino[0].id_anagrafica;
                this.magazzino_aggregato =
                  res.data.magazzino[0].magazzino_aggregato;
                this.codice_magazzino = res.data.magazzino[0].cod_magazzino;
                this.descrizione_magazzino =
                  res.data.magazzino[0].des_magazzino;
                this.id_personale_utente =
                  res.data.magazzino[0].id_personale_utente;
                this.struttura_magazzino = this.parseStrutturaMagazzino(
                  res.data.dettaglio0,
                  1
                );
                this.aggregabile = res.data.magazzino[0].aggregabile;
                this.des_aggregato = res.data.magazzino[0].des_aggregato;

                // Gestisco i riferimenti.
                if (
                  res.data.magazzino[0].riferimenti != null &&
                  res.data.magazzino[0].riferimenti != ""
                ) {
                  this.riferimenti =
                    res.data.magazzino[0].riferimenti.split(",");
                  for (let i = 0; i < this.riferimenti.length; i++) {
                    this.riferimenti[i] = Number(this.riferimenti[i]);
                  }
                }
              }
            } else {
              this.$refs.SnackbarQV.print(
                "error",
                "Errore di comunicazione col server, non è stato possibile caricare i dati."
              );
            }
          })
          .catch((err) => {
            this.request_counter--;
            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          });
      } else {
        this.creaStruttura();
      }

      if (localStorage.getItem("struttura_magazzino_aperto") != "null") {
        this.openIds = JSON.parse(
          localStorage.getItem("struttura_magazzino_aperto")
        );
        this.treeKey++;
      }
    },
    setSingleArticle(item) {
      if (item.singolo_articolo == 0) {
        item.singolo_articolo = 1;
      } else {
        item.singolo_articolo = 0;
      }
      this.treeKey += 1;
    },
    async printItem(item) {
      this.loading = true;
      this.cPage = 0;
      this.pdfs = [];
      this.printItems = [];
      await this.printRecurse(item);
      this.loading = false;
      this.dialogStampa = true;
    },
    async printRecurse(item) {
      if ("children" in item) {
        item.children.forEach(async (child) => {
          await this.printRecurse(child);
        });
      } else {
        var request = {
          controller: "report",
          method: "POST",
          richiesta: {
            action: "getreportpdf",
            token: localStorage.user_token,
            cod_report: "ubicazione",
            parametri: [
              {
                parametro: "@id_ubicazione",
                valore: item.id_magazzino_ubicazione,
              },
            ],
          },
        };

        await this.$store
          .dispatch("api", request)
          .then((res) => {
            if (res.status === 200) {
              if (
                "tipo_messaggio" in res.data &&
                "query_messaggio" in res.data &&
                res.data.tipo_messaggio == 1
              ) {
                this.$refs.SnackbarQV.print("orange", res.data.query_messaggio);
              }
              const response = res.data.result;
              const byteCharacters = atob(response);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], {
                type: "application/pdf",
              });
              const blobUrl = URL.createObjectURL(blob);
              this.pdfs.push(blobUrl);
              this.printItems.push(Object.assign({}, item));
            } else {
              this.$refs.SnackbarQV.print(
                "error",
                "Impossibile generare etichetta"
              );
            }
          })
          .catch((err) => {
            if (
              "tipo_messaggio" in err.response.data &&
              "query_messaggio" in err.response.data &&
              err.response.data.tipo_messaggio == 2
            ) {
              this.$refs.SnackbarQV.print(
                "error",
                err.response.data.query_messaggio
              );
            } else {
              this.$refs.SnackbarQV.print("error", err.toString());
            }
          });
      }
    },
    modifyUbicazione(item) {
      this.tempUbicazione = Object.assign({}, item);
      if (this.tempUbicazione.tipo == null) {
        this.tempUbicazione.tipo = false;
      }
      this.selectedItem = item;
      this.dialogUbicazione = true;
    },
    saveUbicazione() {
      this.selectedItem.larghezza = this.tempUbicazione.larghezza;
      this.selectedItem.altezza = this.tempUbicazione.altezza;
      this.selectedItem.profondita = this.tempUbicazione.profondita;
      this.selectedItem.cod_dettaglio = this.tempUbicazione.cod_dettaglio;
      this.selectedItem.peso_massimo = this.tempUbicazione.peso_massimo;
      this.selectedItem.des_dettaglio = this.tempUbicazione.des_dettaglio;
      this.selectedItem.tipo = this.tempUbicazione.tipo;
      this.dialogUbicazione = false;
    },
    parseStrutturaMagazzino(struttura, level) {
      struttura.forEach((item) => {
        this.maxId = Math.max(this.maxId, item.id_magazzino_ubicazione);

        item.id = item.id_magazzino_ubicazione;

        item.edit = false;
        item.level = level;

        if (item["dettaglio" + level]) {
          item.children = item["dettaglio" + level];
          delete item["dettaglio" + level];

          this.parseStrutturaMagazzino(item.children, level + 1);
        }
      });

      return struttura;
    },
    getTabella() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "'TIPO_MAGAZZINO','ANAGRAFE_COMUNI','ANAGRAFE_PROVINCE','ANAGRAFE_REGIONI','ANAGRAFE_STATI'",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            this.tipologie =
              res.data.TIPO_MAGAZZINO != undefined
                ? res.data.TIPO_MAGAZZINO
                : [];
            this.items_localita =
              res.data.ANAGRAFE_COMUNI != undefined
                ? res.data.ANAGRAFE_COMUNI
                : [];
            this.items_province =
              res.data.ANAGRAFE_PROVINCE != undefined
                ? res.data.ANAGRAFE_PROVINCE
                : [];
            this.items_regioni =
              res.data.ANAGRAFE_REGIONI != undefined
                ? res.data.ANAGRAFE_REGIONI
                : [];
            this.items_nazioni =
              res.data.ANAGRAFE_STATI != undefined
                ? res.data.ANAGRAFE_STATI
                : [];
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricar ei dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricar ei dati."
          );
          return false;
        });
    },
    getTipiMagazzino() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "TIPO_MAGAZZINO",
          filter: "validita = 1",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            this.tipologie = res.data != undefined ? res.data : [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricar ei dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricar ei dati."
          );
        });
    },
    creaStruttura() {
      console.log("entrato crea struttura");
      this.maxId += 1;
      var tempCod = "u";
      for (let i = 0; i < 5 - this.maxId.toString().length; i++) {
        tempCod += "0";
      }
      tempCod += this.maxId;
      this.struttura_magazzino.push({
        children: [],
        singolo_articolo: 0,
        id: this.maxId,
        id_magazzino: this.id,
        id_magazzino_ubicazione: -1,
        des_dettaglio: "Ubicazione",
        cod_dettaglio: tempCod,
        validita: 1,
        id_padre: null,
        id_temp: moment().valueOf(),
        id_temp_padre: null,
        id_utente: localStorage.id,
        level: 1,
        edit: true,
      });
    },
    addChildren(item) {
      if (this.currentEditItem) {
        this.currentEditItem.edit = false;
      }

      this.maxId += 1;

      if (!item.children) {
        this.$set(item, "children", []);
      }

      var tempCod = "u";
      for (let i = 0; i < 5 - this.maxId.toString().length; i++) {
        tempCod += "0";
      }
      tempCod += this.maxId;

      item.children.push({
        id: this.maxId,
        singolo_articolo: 0,
        id_magazzino: this.id,
        id_magazzino_ubicazione: -1,
        des_dettaglio: "Nome",
        cod_dettaglio: tempCod,
        validita: 1,
        id_padre:
          item.id_magazzino_ubicazione != -1
            ? item.id_magazzino_ubicazione
            : null,
        id_temp: moment().valueOf(),
        id_temp_padre: item.id_temp,
        id_utente: localStorage.id,
        level: item.level + 1,
        edit: true,
      });

      this.currentEditItem = item.children[item.children.length - 1];

      this.openIds.push(item.id);
    },
    showDialogPosizioniMultiple(item) {
      this.currentItem = item;
      this.inserimento_posizioni_multiple_visible = true;
    },
    chiudiDialogPosizioniMultiple() {
      this.inserimento_posizioni_multiple_visible = false;

      this.sigla = "";
      this.cifra_iniziale = "";
      this.cifra_finale = "";
    },
    addPosizioniMultiple() {
      if (this.currentEditItem) {
        this.currentEditItem.edit = false;
      }

      const cifra_iniziale = parseInt(this.cifra_iniziale);
      const cifra_finale = parseInt(this.cifra_finale);

      if (cifra_iniziale >= cifra_finale) {
        this.$refs.SnackbarQV.print(
          "error",
          'Il valore di "Cifra finale" deve essere maggiore di "Cifra iniziale"'
        );
        return;
      }

      if (!this.currentItem.children) {
        this.$set(this.currentItem, "children", []);
      }

      for (let i = cifra_iniziale; i <= cifra_finale; i++) {
        this.maxId += 1;

        const name =
          cifra_finale >= 100
            ? this.sigla + (i + "").padStart(3, "0")
            : this.sigla + (i + "").padStart(2, "0");

        this.currentItem.children.push({
          id: this.maxId,
          id_magazzino: this.id,
          id_magazzino_ubicazione: -1,
          des_dettaglio: name,
          cod_dettaglio: "D" + this.maxId,
          validita: 1,
          id_padre:
            this.currentItem.id_magazzino_ubicazione != -1
              ? this.currentItem.id_magazzino_ubicazione
              : null,
          id_temp: moment().valueOf(),
          id_temp_padre: this.currentItem.id_temp,
          id_utente: localStorage.id,
          level: this.currentItem.level + 1,
          edit: false,
        });
      }

      this.openIds.push(this.currentItem.id);

      this.chiudiDialogPosizioniMultiple();
    },
    saveName(item) {
      item.edit = false;
    },
    editItem(item) {
      if (this.currentEditItem) {
        this.currentEditItem.edit = false;
      }

      item.edit = true;
      this.currentEditItem = item;
    },
    deleteItem(item) {
      if (item.validita == 1) {
        item.validita = 0;
      } else {
        item.validita = 1;
      }

      /*if (item.level == 2) {
        this.struttura_magazzino[0].children = this.struttura_magazzino[0].children.filter((el) => {
          return el.id != item.id;
        });
      } else {
        this.removeItem(this.struttura_magazzino[0], item.id, item.level);
      }*/
    },
    /*removeItem(item, id, level) {
      item.children.forEach((el) => {
        if (el.level == level) {
          if (el.id == id) {
            item.children = item.children.filter((el2) => {
              return el2.id != id;
            });
          }
        } else {
          if (el.children) {
            return this.removeItem(el, id, level);
          }
        }
      });
    },*/
    convertStrutturaMagazzino(struttura) {
      if (struttura.children) {
        struttura["dettaglio" + struttura.level] = struttura.children;
        delete struttura.children;

        if (struttura["dettaglio" + struttura.level].length > 0) {
          struttura["dettaglio" + struttura.level].forEach((el) => {
            this.convertStrutturaMagazzino(el);
          });
        } else {
          delete struttura["dettaglio" + struttura.level];
        }
      }
    },
    async salvaMagazzino() {
      // Se non è un magazzino aggregato devo inserire almeno un livello di struttura.
      if (!this.struttura_magazzino[0] && this.magazzino_aggregato == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Inserire almeno un livello di ubicazione."
        );
        return;
      }

      if (this.magazzino_aggregato == 0) {
        this.convertStrutturaMagazzino(this.struttura_magazzino[0]);
      } else {
        this.struttura_magazzino = new Array();
      }

      // Costruisco i riferimenti.
      let riferimenti_tmp = "";

      if (this.riferimenti != null && this.riferimenti != "") {
        this.riferimenti.forEach((r) => {
          riferimenti_tmp += `${r},`;
        });
      }

      if (riferimenti_tmp.length > 0) {
        riferimenti_tmp = riferimenti_tmp.slice(0, -1);
      }

      var itemRequest = {
        magazzino: [
          {
            id_magazzino: this.id,
            sede_magazzino: this.sede_magazzino,
            id_tipo_magazzino: this.tipologia_magazzino,
            cod_magazzino: this.codice_magazzino,
            des_magazzino: this.descrizione_magazzino,
            id_personale_utente: this.id_personale_utente,
            indirizzo: this.indirizzo,
            cap: this.cap,
            localita: this.comune,
            id_anagrafica: this.id_anagrafica,
            magazzino_aggregato: this.magazzino_aggregato,
            riferimenti: riferimenti_tmp,
            provincia: this.provincia,
            nazione: this.nazione,
            visibile: 1,
            validita: 1,
            giacenza: 1,
            disponibilita: 1,
            conto_lavoro: null,
            ordine: null,
          },
        ],
        dettaglio0: this.struttura_magazzino,
      };

      this.showOverlay = true;
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setmagazzinoubicazione",
          token: localStorage.user_token,
          ...itemRequest,
        },
      };

      await this.$store.dispatch("api", request).then(async (res) => {
        if (res.status == 200) {
          if (this.id == -1) {
            this.$refs.SnackbarQV.print(
              "success",
              `Creazione magazzino N. ${res.data} avvenuta con successo.`
            );

            const that = this;
            let timer = setTimeout(function () {
              /*that.$router.push({
                name: "edit-magazzino",
                params: { id: res.data },
              });*/
              localStorage.setItem("struttura_magazzino_aperto", "null");
              that.$router.push({ name: "home-magazzino" });
              clearTimeout(timer);
            }, 3000);
          } else {
            this.$refs.SnackbarQV.print(
              "success",
              `Aggiornamento magazzino N. ${res.data} avvenuta con successo.`
            );

            const that = this;
            let timer = setTimeout(function () {
              localStorage.setItem("struttura_magazzino_aperto", "null");
              that.$router.push({ name: "home-magazzino" });
              clearTimeout(timer);
            }, 3000);
          }
        }
      });
      this.inizializza();
    },
  },
};
</script>

<style>
.edit-magazzino .v-treeview-node__label {
  font-size: 16px;
}
</style>
